export const SET_TEAM_NAME = 'PAGE_SET_TEAM_NAME';
export const SET_USER_NAME = 'PAGE_SET_USER_NAME';
export const SET_PASSWORD = 'PAGE_SET_PASSWORD';
export const SET_MESSAGE = 'PAGE_SET_MESSAGE';

export function setTeamName(teamName) {
  return {
    type: SET_TEAM_NAME,
    teamName
  };
}

export function setUserName(userName) {
  return {
    type: SET_USER_NAME,
    userName
  };
}

export function setPassword(password) {
  return {
    type: SET_PASSWORD,
    password
  };
}

export function setMessage(message, error = false) {
  return {
    type: SET_MESSAGE,
    message,
    error
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/XLogin.js